import { ONE_MINUTE_IN_SECONDS, ONE_SECOND_IN_MILLISECONDS } from "./time"

const DEFAULT_REFETCH_INTERVAL =
  5 * ONE_MINUTE_IN_SECONDS * ONE_SECOND_IN_MILLISECONDS

const DEFAULT_STALE_TIME = DEFAULT_REFETCH_INTERVAL

const FETCH_ONLY_ONCE_OPTIONS = { staleTime: Infinity, gcTime: Infinity }

export default {
  DEFAULT_REFETCH_INTERVAL,
  DEFAULT_STALE_TIME,
  FETCH_ONLY_ONCE_OPTIONS,
}
